export const closeModal = (modal) => {
  const body = document.body;

  modal.classList.remove("opened");
  body.classList.remove("no-scroll");
};